import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {Button, Checkbox, Modal} from "antd";
import {IconClose} from "../Icon";
import {imgPathPerfix, isDarkMode} from "../utils";
import {useTranslation} from "react-i18next";
import {KEYS} from "../../@excalidraw/packages/excalidraw/keys";
import global from "@/global";
import {KEY_AUTO_SAVE_CLOUD_DB, KEY_DONOT_SHOW_REMOVE_IMAGE_TIP, KEY_FILE_DIR, MAX_Z_INDEX} from "@/Const";

let mCallback:any;
let mCancelCallback:any;

const DialogMessageBox = forwardRef((props,ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onShowDialogWithoutCancel:onShowDialogWithoutCancel,
        onShowDialogOkCancel:onShowDialogOkCancel,
        onCloseDialog:onCloseDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [title,setTitle]=useState("");
    const [content,setContent]=useState("");
    const [okText,setOkText] = useState('');
    const [cancelText,setCancelText] = useState('');
    const [maskCloseable,setMaskCloseable] = useState(true);

    const {t} = useTranslation();

    function onKeyDown(event:any){
        if (isShowDialog && event.key == KEYS.ENTER){
            event.preventDefault();
            event.stopPropagation();
            onOkClick();
        }
    }

    useEffect(()=>{
        document.body.addEventListener('keyup',onKeyDown);
        return ()=> {
            document.body.removeEventListener('keyup', onKeyDown);
        }
    })

    const onShowDialog = (title,content,okText,callback:any)=>{
        setIsShowDialog(true);
        setTitle(title);
        setContent(content);
        setOkText(okText);
        setCancelText(t('Cancel'))
        mCallback = callback;
        mCancelCallback = null;
    }

    const onShowDialogOkCancel = (title,content,cancelText,okText,cancelCallback:any,callback:any,maskCloseable)=>{
        setIsShowDialog(true);
        setTitle(title);
        setContent(content);
        setCancelText(cancelText);
        setOkText(okText);
        mCallback = callback;
        mCancelCallback = cancelCallback;
        if (maskCloseable != undefined && maskCloseable != null){
            setMaskCloseable(maskCloseable);
        }
    }

    const onShowDialogWithoutCancel = (title,content,okText,callback:any)=>{
        setIsShowDialog(true);
        setTitle(title);
        setContent(content);
        setOkText(okText);
        mCallback = callback;
        mCancelCallback = null;
    }

    const onCloseDialog =()=>{
        setIsShowDialog(false)
    }

    const onOkClick = ()=>{
        let bClose = true;
        if (mCallback != undefined){
            bClose = mCallback()??true;
        }
        if (bClose){
            setIsShowDialog(false);
        }
    }

    return(
        <Modal width='468px' zIndex={MAX_Z_INDEX+ 9999999}
               afterOpenChange={(e)=>{
                   global.g_showDialogs.dialogInfos = e;
               }}
               maskClosable={maskCloseable}
               onCancel={(e)=> {
                   if (e.target === e.currentTarget) {
                       // 通过蒙层点击关闭
                       window.closeDialogFileImportLoading();
                   }
                   setIsShowDialog(false)
               }} closable={true} open={isShowDialog} closeIcon={<img
            className='img-mini-small-10 cursor-pointer'
            src={imgPathPerfix() + (isDarkMode() ? "close_white_1.png" : "close_black.png")} onMouseDown={()=>{
            window.closeDialogFileImportLoading();
            //执行取消
            setIsShowDialog(false);
            if (mCancelCallback) {
                mCancelCallback();
            }
        }}/>} centered={true} style={{zIndex: '3000'}} footer={null}>
            <div onMouseDown={(e)=>{
                e.stopPropagation();
            }}>
                <div className='flex-row-vertical-center'>
                    {/*<img className='img-mini-small' src={imgPathPerfix()+"icon_info.png"}/>*/}
                    <span className='dialog-title' style={{marginLeft:'0px'}}>{title}</span>
                </div>
                <div className='line-e4-tb-12'></div>


                <p style={{marginTop:'16px'}} dangerouslySetInnerHTML={{__html:content}}></p>

                {
                    title == t("Remove image") &&
                    <div className={'flex-row-vertical-center mt-22'}>
                        <Checkbox onChange={(e)=>{
                            localStorage.setItem(KEY_DONOT_SHOW_REMOVE_IMAGE_TIP,e?'true':'false');
                        }} style={{color:'var(--text-color)'}}>{t("DontShowAgain")}</Checkbox>
                    </div>
                }

                {
                    okText &&
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '26px',
                        marginBottom: '0px'
                    }}>
                        {
                            cancelText &&
                            <Button
                                style={{height: '34px'}}
                                className='large-w-button button-border-gray-style button-min-width font-size-14 font-family-medium'
                                onClick={() => {
                                    setIsShowDialog(false);
                                    if (mCancelCallback) {
                                        mCancelCallback();
                                    }
                                }}>{cancelText}</Button>
                        }
                        <Button
                            className='large-w-button button-solid-style button-min-width font-size-14 font-family-medium'
                            type="primary"
                            onClick={() => onOkClick()}
                            style={{marginLeft: cancelText?'26px':'0px',background:okText == t("Logout")?"#FF404C":"var(--button-background-color)"}}
                            htmlType={"submit"}>{okText}</Button>
                    </div>
                }
                {
                    title == t("SaveToCloud") &&
                    <div className={'flex-center mt-22'}>
                        <Checkbox onChange={(e)=>{
                            localStorage.setItem(KEY_AUTO_SAVE_CLOUD_DB,e?'true':'false');
                        }} style={{color:'var(--text-color)'}}>{t("DontAskAgain")}</Checkbox>
                    </div>
                }
            </div>
        </Modal>
    )
})

export default DialogMessageBox;